<section>
    <!-- 內容區塊 -->
    <div class="content-block">
        <div class="block-header">
            <div class="product-name">
                <h1>{{product?.product_number}}</h1>

                <h2 *ngIf="product?.type; else null_content">{{"PRODUCT.PRODUCT_TYPE.TYPE_" + product?.type | translate }}</h2>
                <ng-template #null_content>{{"PRODUCT.PRODUCT_TYPE.TITLE" | translate }}</ng-template>
            </div>
            <div class="product-img">
                <img [src]="product?.image_path" [alt]="product?.product_number + '圖片'">
            </div>
        </div>
        <div class="block-body">
            <!-- 產品描述 -->
            <div class="body-part description">
                <h4>{{"PRODUCT.PRODUCT_DETAIL.CONTENT.DESCTIPTION" | translate }}</h4>
                <p>{{product?.description}}</p>
            </div>
            <!-- 技術規格 -->
            <div class="body-part spec">
                <h4>{{"PRODUCT.PRODUCT_DETAIL.CONTENT.SPEC" | translate }}</h4>
                <ng-container [ngSwitch]="product?.type">
                    <!-- 導熱硅膠 -->
                    <ng-template [ngSwitchCase]="1">
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.WMK" | translate}}：</span>
                            <span>{{product?.features?.thermal_conductivity | number: '1.1-1'}}</span>
                        </p>
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.TEMPERATURE" | translate}}：</span>
                            <span>{{product?.features?.temperature_min| number: '1.1-1'}}</span>
                            <span>~</span>
                            <span>{{product?.features?.temperature_max| number: '1.1-1'}}</span>
                        </p>
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.THICKNESS" | translate}}：</span>
                            <span>{{product?.features?.thickness_min| number: '1.1-1'}}</span>
                            <span>~</span>
                            <span>{{product?.features?.thickness_max| number: '1.1-1'}}</span>
                        </p>
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.HARDNESS" | translate}}：</span>
                            <span>{{product?.features?.hardness_str}}</span>
                            
                        </p>
                    </ng-template>
                    <!-- 導熱硅脂 -->
                    <ng-template [ngSwitchCase]="2">
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.WMK" | translate}}：</span>
                            <span>{{product?.features?.thermal_conductivity| number: '1.1-1'}}</span>
                        </p>
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.TEMPERATURE" | translate}}：</span>
                            <span>{{product?.features?.temperature_min| number: '1.1-1'}}</span>
                            <span>~</span>
                            <span>{{product?.features?.temperature_max| number: '1.1-1'}}</span>
                        </p>
                        <p>
                            <span>{{"PRODUCT.PRODUCT_LIST.CARD.SPEC.VOLATILE_COMPONENT" | translate}}：</span>
                            <span>{{product?.features?.volatile_component| number: '1.1-1'}}%</span>
                            <span>{{"("}}</span>
                            <span>{{product?.features?.volatile_temperature| number: '1.1-1'}}℃, </span>
                            <span>{{product?.features?.volatile_hour| number: '1.1-1'}}hr </span>
                            <span>{{")"}}</span>
                        </p>
                    </ng-template>
                </ng-container>
            </div>
            <!-- 產品應用 -->
            <div class="body-part application">
                <h4>{{"PRODUCT.PRODUCT_DETAIL.CONTENT.APPLICATION" | translate }}</h4>
                <p>
                    <ng-container *ngFor="let line of productApplication">
                        <span>{{line}}</span><br>
                    </ng-container>
                </p>
            </div>
            <!-- 物性表 -->
            <div class="body-part feature-img">
                <h4>{{"PRODUCT.PRODUCT_DETAIL.CONTENT.FEATURE_FORM" | translate }}</h4>
                <img [src]="product?.feature_from_path" [alt]="product?.product_number + '物性表'">
            </div>
        </div>
    </div>
    <!-- 右側欄 -->
    <div class="right-block">
        <!-- 相關報告 -->
        <div class="block-part reports">
            <h4>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.REPORTS" | translate }}</h4>
            <div class="report-list">
                <ng-container *ngFor="let report of product?.reports">
                    <div class="report" (click)="downloadStaticFile(report.file_name)">{{report.name}}</div>
                </ng-container>
                <div
                    *ngIf="product"
                    class="report"
                    [routerLink]="['/custom/product/autodraw']" 
                                    [queryParams]="{
                                        type: product.type,
                                        pn: product.product_number,
                                    }"
                >
                    <span *ngIf="product.type !== TIM_TYPE['TMP']; else tmpType">{{"BUTTON.AUTODRAW" | translate}}</span>
                    <ng-template #tmpType>{{"BUTTON.CONTACT_QUOTE" | translate}}</ng-template>
                </div>
                
            </div>
        </div>
        <!-- 應用領域 -->
        <div class="block-part application-field">
            <h4>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.FIELD" | translate }}</h4>
            <div class="tag-list">
                <ng-container *ngFor="let field of product?.application_field">
                    <div class="tag">{{field.name}}</div>
                </ng-container>
            </div>
        </div>
        <!-- 其他產品 -->
        <div class="block-part another-product">
            <h4>
                <span>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.ANOTHER_PRODUCT.ANOTHER" | translate }}</span>
                <span *ngIf="product?.type">{{"PRODUCT.PRODUCT_TYPE.TYPE_" + product?.type | translate }}</span>
                <span>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.ANOTHER_PRODUCT.PRODUCT" | translate }}</span>
            </h4>
            <table class="product-table">
                <thead>
                    <tr>
                        <td>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.ANOTHER_PRODUCT.PRODUCT_NUMBER" | translate }}</td>
                        <td>{{"PRODUCT.PRODUCT_DETAIL.SIDE_BLOCK.ANOTHER_PRODUCT.PRODUCT_IMAGE" | translate }}</td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let prod of productList">
                        <tr [routerLink]="['..', prod?.id]">
                            <td>
                                {{prod?.product_number}}
                            </td>
                            <td>
                                <img [src]="prod?.image_path" [alt]="prod.product_number + '產品圖'">
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
<section>